import React from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);

export function ExpertiseChart({ graphData }: { graphData: any }) {
  if (!graphData) return null;

  return <Doughnut redraw={true} data={graphData} />;
}
